<template>       
  <v-layout text-xs-center wrap style="min-height: 550px">    
    <v-flex xs12 mt-4>
      <v-img
        :src="require('@/assets/logo.png')"
        class="my-3"
        contain
        height="150"
      ></v-img>
    </v-flex>          
    <v-flex mb-4>      
      <h2 class="display-1">السَّلاَمُ عَلَيْكُمْ وَرَحْمَةُ اللهِ وَبَرَكَاتُه</h2>
      <h1 class="display-1 font-weight-bold mb-3">
        {{ language ? 'Welcome to PPDB homepage':'Selamat Datang di portal PPDB'}}
      </h1>
      <h1 class="text-xs-center my-3" style="text-align:center !important"><span style="color:#1B5E10">PERGURUAN ISLAM</span> AR RISALAH</h1>
      <v-card style="max-width:700px; width:100%;" class="mx-auto" elevation="0">
        <v-card-text>
          <p class="subheading font-weight-regular text--center">
            Silahkan ananda pilih jenjang pendidikan yang akan dituju :            
            <center>
              <!--<v-radio-group label="" v-model="dtingkat_id" row style="max-width:350px !important">-->
                <v-layout row wrap class="mx-auto my-2">
                  <v-flex xs4>
                    <v-card :color="dtingkat_id ==1 ?'red':'white'" :dark="dtingkat_id==1" @click="dtingkat_id=1">
                      <v-card-text>
                        <!--<v-radio label="SD"  :value="1"></v-radio>-->
                        <input type="radio" v-model="dtingkat_id" class="mr-1"  :value="1"/> SD
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-card style="display:none" :color="dtingkat_id ==2 ?'primary':'white'" :dark="dtingkat_id==2"  @click="dtingkat_id=2">
                      <v-card-text>
                        <!--<v-radio label="SMP" :value="2"></v-radio>-->
                        <input type="radio" v-model="dtingkat_id" class="mr-1"  :value="2"/> SMP
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-card  style="display:none" :color="dtingkat_id ==3 ?'blue-grey':'white'" :dark="dtingkat_id==3"  @click="dtingkat_id=3">
                      <v-card-text>
                        <!--<v-radio label="MA" :value="3"></v-radio>-->
                        <input type="radio" v-model="dtingkat_id" class="mr-1"  :value="3"/> MA
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>                                                
                <!--<v-radio label="STEI" :value="7"></v-radio>-->
              <!--</v-radio-group>-->
            </center>
          </p>
          <p class="subheading font-weight-regular text--center" v-if="dtingkat_id">
            Selanjutnya, Silahkan pilih jalur yang sesuai dengan ananda <strong>(perhatikan syarat & ketentuan)</strong> :            
            <center>
              <v-radio-group label="" color="black" v-model="djalur_id" row style="max-width:700px !important; width:100%">
                <v-layout row wrap style="width:100%">
                  <template v-for="(jalur,i) in jalurs">
                    <template v-if="jalur.id == 99"></template>
                    <v-flex xs12 sm6 :key="i" v-else-if="jalur.tingkat.includes(dtingkat_id)">
                      <v-card :color="djalur_id == jalur.id ?'teal lighten-4':'grey lighten-4'">
                        <v-toolbar @click="djalur_id = jalur.id" flat dense :color="djalur_id == jalur.id ?'teal':'grey lighten-4'" :dark="djalur_id==jalur.id">
                          <input type="radio" v-model="djalur_id" :label="jalur.name" class="mr-3"  :value="jalur.id"/> {{jalur.name}} 
                        </v-toolbar>
                        <v-divider/>
                        <v-card-text class="pa-2 caption">
                          <strong>Syarat & ketentuan :</strong>
                          <ul>
                            <template v-for="(syarat, j) in jalur.syarats" >
                              <template v-if="typeof syarat == 'object'">
                                <li v-if="syarat[dtingkat_id]" :key="j+'syarat'"><div v-html="syarat[dtingkat_id]"></div></li>
                              </template>
                              <template v-else>
                                <li :key="j+'syarat'"><div v-html="syarat"></div></li>
                              </template>
                            </template>
                          </ul>                                                      
                        </v-card-text>                        
                        <v-divider/>
                        <v-card-text v-if="jalur.id == 4 && dvoucher_error">
                          <v-alert :value="true" type="error">
                            {{dvoucher_error}}
                          </v-alert>
                        </v-card-text>                        
                        <form @submit.prevent="setVoucher()">                          
                          <v-toolbar flat dense v-if="jalur.id==4" >
                              <input :disabled="djalur_id != 4" required v-model="dvoucher" solo placeholder="Kode Voucher disini" />                                                                     
                              <v-btn type="submit" v-if="!dvoucher_valid" :loading="dVoucher_loading" color="primary" round>CEK</v-btn>                          
                              <v-chip color="success" dark v-else><v-icon>check</v-icon>Terpasang</v-chip>
                          </v-toolbar>
                        </form>
                      </v-card>
                    </v-flex>                  
                  </template>
                </v-layout>                                                
                <!--<v-radio label="STEI" :value="7"></v-radio>-->
              </v-radio-group>            
            </center>
          </p>
          <p class="subheading font-weight-regular" v-if="djalur_id">
            Klik button <strong>Selanjutnya</strong>, ananda akan diminta untuk mengisi form administrasi. 
          </p>
        </v-card-text>
      </v-card>
      <template v-if="language">
        <p>
          For help and collaboration with other Information please chat me in right bottom,
          <br>please join our online
          <a href="https://arrisalah.sch.id" target="_blank">https://arrisalah.sch.id</a>
        </p>        
      </template>      
      <template v-else>
        <p>
          Butuh bantuan, atau ingin berbagi informasi, silahkan chat kami dengan mengklik icon whatsapp di pojok kanan bawah          
          <br>atau kunjungi situs kami di 
          <a href="https://arrisalah.sch.id" target="_blank">https://arrisalah.sch.id</a>
        </p>        
      </template>  
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="px-3" :disabled="!tingkat_id || !jalur_id || (jalur_id == 4 && dvoucher_valid == false)" @click="$emit('next', true)">
          Selanjutnya
        </v-btn>
      </v-card-actions>
    </v-flex>    
  </v-layout>      
</template>
<script>
import Model  from '@/models/dashboard';
const  model = new Model();

export default {
  props:['tingkat_id', 'jalur_id', 'voucher', 'fm'],
  name:'step1',  
  components: { 
  },
  data:()=>({  
    language : 0,
    jalurs:[
      {
        id:1,
        name: 'Reguler',
        tingkat: [1,2,3],
        syarats: [
          'Bisa diikuti oleh pendaftar pada umumnya.',
          'Mengisi form pendaftaran & upload pasfoto 3x4',
          {
            1:'Membayar uang pendaftaran 100rb',
            2:'Membayar uang pendaftaran 250rb',
            3:'Membayar uang pendaftaran 300rb',
          },                    
          'Mengisi angket untuk orang tua',
          {
            1:'Mengupload scan Akta Kelahiran dalam format .pdf',
            2:'Mengupload scan surat keterangan nilai yang ditandatangani Kepala Sekolah asal, (template dapat di download pada step selanjutnya)',
            3:'Mengupload scan surat keterangan nilai yang ditandatangani Kepala Sekolah asal, (template dapat di download pada step selanjutnya)',
          },
          {
            1:'',
            2:'Mengikuti Ujian Akademik',
            3:'Mengikuti Ujian Akademik',
          },
          {
            1:'',
            2:'Mengikuti Tes Baca Qur\'an',                              
            3:'Mengikuti Tes Baca Qur\'an',                              
          }          
        ]
      },
      {
        id:3,
        tingkat: [1],
        name: 'Internal',
        syarats:[
          {
            1:'Berasal dari RA Arrisalah Sumbar',
            2:'Berasal dari SDQu Arrisalah Sumbar',
            3:'Berasal dari SMP Arrisalah Sumbar'
          },
          'Mengisi form pendaftaran & upload pasfoto 3x4',          
          {
            1:'Membayar uang pendaftaran 50rb',
            2:'Membayar uang pendaftaran 100rb',
            3:'Membayar uang pendaftaran 100rb',
          },
          'Mengisi angket untuk orang tua',
          {
            1:'',
            2:'',
            3:'',
          }, 
          {
            1:'',
            2:'Tidak mengikuti tes akademik dan baca quran',
            3:'Tidak mengikuti tes akademik dan baca quran',
          },          
        ],
      },
      {
        id:2,
        tingkat: [2,3],
        name: 'Prestasi',
        syarats: [
          {
            1:'',
            2:'Hanya bisa diikuti oleh pendaftar yang memiliki prestasi sebagai berikut:<br/><strong>Kriteria kategori A</strong><ol><li>Juara 1,2 dan 3 OSN/KSN/KSM tingkat nasional</li><li>Hafizh 30  juz lulus tes oleh penguji ar risalah</li><li>Juara 1,2 dan 3 MHQ tingkat Nasional (kategori 1 juz atau lebih)</li></ol><strong>Kriteria kategori B</strong><ol><li>Juara 1,2 dan 3 OSN/KSN/KSM tingkat provinsi</li><li>Hafizh 10  juz untuk masuk MA (lulus tes oleh penguji ar risalah)</li><li>Juara 1,2 dan 3 MHQ tingkat Provinsi/utusan Provinsi ke Nasional (kategori 1 juz atau lebih)</li></ol>',
            3:'Hanya bisa diikuti oleh pendaftar yang memiliki prestasi sebagai berikut:<br/><strong>Kriteria kategori A</strong><ol><li>Juara 1,2 dan 3 OSN/KSN/KSM tingkat nasional</li><li>Hafizh 30  juz lulus tes oleh penguji ar risalah</li><li>Juara 1,2 dan 3 MHQ tingkat Nasional (kategori 5 juz atau lebih)</li></ol><strong>Kriteria kategori B</strong><ol><li>Juara 1,2 dan 3 OSN/KSN/KSM tingkat provinsi</li><li>Hafizh 20  juz untuk masuk MA (lulus tes oleh penguji ar risalah)</li><li>Juara 1,2 dan 3 MHQ tingkat Nasional/utusan Provinsi ke Nasional (kategori 5 juz atau lebih)</li></ol>',
          },
          'Upload foto/scan sertifikat prestasi',
          'Mengisi form pendaftaran & upload pasfoto 3x4',          
          'Tidak membayar uang pendaftaran',
          'Mengisi angket untuk orang tua',
          'Tidak mengikuti ujian akademik khusus prestasi dalam bidang akademik',
          'Tidak mengikuti tes qur\'an khusus prestasi dalam bidang qur\'an',                              
        ]
      },      
      {
        id:4,
        tingkat: [2,3],
        name: 'Undangan',
        syarats:[
          'Punya Kode Voucher dan menginputkan pada kolom dibawah dan klik CEK',
          'Mengisi form pendaftaran & upload pasfoto 3x4',                  
          'Mengisi angket untuk orang tua',
          'Tidak mengikuti tes akademik dan baca quran'
        ],
      }
    ],
    dtingkat_id: null,
    djalur_id: null,
    dvoucher: null,
    dVoucher_loading: false,
    dvoucher_error:null,
    dvoucher_valid:false,
    first: null
  }),
  watch:{
    dtingkat_id(nVal){
      this.djalur_id = null
      this.dvoucher = null
      this.$emit('update:tingkat_id', nVal)      
    },
    djalur_id(nVal){
      this.dvoucher = null
      this.$emit('update:jalur_id', nVal)
    },
    dvoucher_valid(nVal){
      if(nVal)this.$emit('update:voucher_valid', nVal)
    },
    dvoucher(nVal){
      if(!nVal) this.dvoucher_error = null
      this.$emit('update:voucher', nVal)
    },
    tingkat_id(nVal){
      this.dtingkat_id = nVal            
    },
    jalur_id(nVal){
      this.djalur_id = nVal      
    },
    voucher(nVal){
      this.voucher = nVal      
    }
  },
  computed: {},  
  mounted(){},
  methods:{
    setVoucher(){
      this.djalur_id = 4      
      this.dVoucher_loading = true;
      this.dvoucher_error   = null;
      this.dvoucher_valid   = false
      model.setVoucher({code:this.dvoucher}).then(res=>{
        this.dVoucher_loading = false;
        if(res.status == 200){
          this.$emit('update:voucher_valid', true)
          this.dvoucher_valid = true
        }else{
          this.$emit('update:voucher_valid', false)
          this.dvoucher_error = res.data.message
        }
      })
    }
  }
};
</script>


